export default {
  IS_API_PROGRESS: 'IS_API_PROGRESS',
  IS_JOB_APPLICATION_API_IN_PROGRESS: 'IS_JOB_APPLICATION_API_IN_PROGRESS',
  SET_JOB_APPLICATIONS: 'SET_JOB_APPLICATIONS',
  CONCAT_JOBS: 'CONCAT_JOBS',
  UNSET_SELECTED_JOB: 'UNSET_SELECTED_JOB',
  SET_SELECTED_JOB: 'SET_SELECTED_JOB',
  TOGGLE_SALARY_RANGE: 'TOGGLE_SALARY_RANGE',
  SALARY_SELECTED: 'SALARY_SELECTED',
  CITY_SELECTED: 'CITY_SELECTED',
  TOGGLE_CITY: 'TOGGLE_CITY',
  RESET_FEED: 'RESET_FEED',
  TOGGLE_JOB_ROLE: 'TOGGLE_JOB_ROLE',
  ROLES_SELECTED: 'ROLES_SELECTED',
  SELECT_JOB_APPLICATION: 'SELECT_JOB_APPLICATION',
  SET_TRACK_INFO: 'SET_TRACK_INFO',
  TOGGLE_LOCALITY: 'TOGGLE_LOCALITY',
  LOCALITY_SELECTED: 'LOCALITY_SELECTED',
  LOADING_USER_SETTING: 'LOADING_USER_SETTING',
  SET_USER_SETTINGS: 'SET_USER_SETTINGS',
  TOGGLE_WORK_AREA: 'TOGGLE_WORK_AREA',
  TOGGLE_LOGIN: 'TOGGLE_LOGIN',
  TOGGLE_OTP: 'TOGGLE_OTP',
  SET_MITRA_CALL_FLOW_STATE: 'SET_MITRA_CALL_FLOW_STATE',
  SET_SELECTED_JOB_FOR_CALL: 'SET_SELECTED_JOB_FOR_CALL',
  SET_CALLING_THROUGH_APPLY_FLOW: 'SET_CALLING_THROUGH_APPLY_FLOW',
};
